import React from "react";
import LeftPipe from "../components/LeftPipe";
import ImageCircle from '../components/ImageCircle';
import Quote from '../components/Quote';
import cynthia from '../assets/photos/headshots/m-headshot-john.png';
import image11 from '../assets/elements/bubble/Bubble-image-11.png';
import image12 from '../assets/elements/bubble/Bubble-image-12.png';
export default ({ isActive }) => {
  const message = 'Our purpose is to push at the boundaries of science, developing new medicines for the millions of people out there in need. But we can’t do it without the partnership of patients. Only by working together can we advance the next generation of treatments, safely and effectively, and bring new hope to patients and their loved ones.';
  const quote = {
    author: 'John Tsai',
    position: 'Head of Global Drug Development and Chief Medical Officer at Novartis',
    img: cynthia,
    quote: [message]
  }
  return (
    <div className="component hide-overflow">
        {isActive && (
          <>
            <ImageCircle imgSrc={image11} position={'top'} hideMobile={true}/>
            <ImageCircle imgSrc={image12} position={'left'} />
            <LeftPipe />
          </>
        )}
        <Quote isActive={isActive} quote={quote} position={'top'} />
    </div>
  );
};
